import { render, staticRenderFns } from "./TimeTag.vue?vue&type=template&id=0ba0982e&"
import script from "./TimeTag.vue?vue&type=script&lang=ts&"
export * from "./TimeTag.vue?vue&type=script&lang=ts&"
import style0 from "./TimeTag.vue?vue&type=style&index=0&id=0ba0982e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports